<template>
    <div id="pdf_view" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="contentViewLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content" style="background:none;border: none;">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div>
                                {{ src }}
                                <img src="@/assets/images/download.png" class="mt-4 mb-3"
                                    style="width: 64px;height: 64px;" alt="Download Icon">
                                <div class="font-grey font-size-16 font-weight-bold">{{ src.title }}</div>
                            </div>
                            <div class="mt-1 font-grey font-size-12"><i>
                                    <a :href="src.cdnUrl" target="_blank">{{ src.fileName + '.' + src.ext }}</a></i>
                            </div>
                            <button type="button" class="close image-close-btn" data-dismiss="modal" aria-hidden="true"
                                @click="$emit('close')">&times;</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModelPdfView",
    data() {
        return {
            src: null
        }
    },
    methods: {
        show(src) {
            this.src = src;
            $('#pdf_view').modal();
        },
        hide() {
            $('#pdf_view').modal('hide');
        }
    }
}
</script>

<style>
.image-close-btn {
    position: absolute;
    top: 5%;
    right: 4%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    color: white;
    padding: 12px 24px;
    cursor: pointer;
}
</style>
